<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Deleted Branches</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-branches' }">Back</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="branches.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(branche, index) in filteredBranches" :key="index">
                  <th scope="row">{{ branche.id }}</th>
                  <td>{{ branche.name_ar }}</td>
                  <td>{{ branche.name_en }}</td>
                  <td>
                    <button class="me-2 btn btn-success" @click="restoreBranche(branche.id)">
                      Restore
                    </button>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No deleted branches found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
import axios from "../../Axios";
export default {
  name: "AllBranches",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [],
      branches: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
      ],
    };
  },

  async created() {
    this.fetchBranches();
  },

  computed: {
    filteredBranches() {
      if (!this.searchTerm) {
        return this.branches;
      }
      const term = this.searchTerm.toLowerCase();
      return this.branches.filter((branche) =>
        branche.name.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch cities
    async fetchBranches() {
      try {
        const response = await axios.get(
          `/admin/admin/branch/get-delete-soft`
        );
        this.branches = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
        console.log(this.users);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },

    restoreBranche(id) {
      console.log("restore branch id: ", id);
      axios
        .post(`/admin/admin/branch/restore?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchBranches();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>


<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>
